import { z } from 'zod';
import { cursorPageSchema, isoDateTimeSchema, uuidSchema } from './common.js';
import { recipeSummarySchema } from './recipes.js';
import { categoryHueSchema } from './themes.js';
export const collectionSchema = z.object({
    id: uuidSchema,
    ownerId: uuidSchema,
    householdId: uuidSchema.nullable(),
    name: z.string(),
    description: z.string().nullable(),
    coverAssetId: uuidSchema.nullable(),
    coverUrl: z.string().nullable(),
    /** One of the ten category hues; null = derived from the name. */
    color: categoryHueSchema.nullable().optional(),
    recipeCount: z.number().int(),
    offlineHint: z.boolean().optional(),
    version: z.number().int(),
    createdAt: isoDateTimeSchema,
    updatedAt: isoDateTimeSchema,
});
export const collectionWriteSchema = z.object({
    name: z.string().trim().min(1).max(120),
    description: z.string().trim().max(2000).nullable().optional(),
    coverAssetId: uuidSchema.nullable().optional(),
    householdId: uuidSchema.nullable().optional(),
    color: categoryHueSchema.nullable().optional(),
});
export const collectionUpdateSchema = collectionWriteSchema.partial().extend({
    version: z.number().int().nonnegative(),
});
export const collectionDetailSchema = collectionSchema.extend({
    recipes: z.array(recipeSummarySchema.extend({ position: z.number().int() })),
});
export const collectionRecipesRequestSchema = z.object({
    recipeIds: z.array(uuidSchema).min(1).max(200),
});
export const collectionReorderRequestSchema = z.object({
    recipeIds: z.array(uuidSchema).min(1).max(1000),
});
export const collectionPageSchema = cursorPageSchema(collectionSchema);
//# sourceMappingURL=collections.js.map